import { connect, MapStateToProps } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { getShopItemsStreamId } from '../../../../../streams/shop';
import { ShopItemType } from '../../../../../../types/shop';
import { AppState } from '../../../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../../selectors/users';
import { Props } from './PrintsSlider';

type StateProps = Pick<
  Props,
  'streamId' | 'prints' | 'total' | 'isOwner' | 'username' | 'isPaywallUpdates'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const streamId = getShopItemsStreamId(ShopItemType.PRINTS);
  return {
    streamId,
    prints: getDeviationsByIds(
      state,
      streamSelectors.getItems(state, streamId)
    ),
    total: streamSelectors.getTotal(state, streamId),
    isOwner: isCurrentUserProfileOwner(state),
    username: getProfileOwnerUser(state).username,
    isPaywallUpdates: flagEnabled(state, 'paywall_updates'),
  };
};

export default connect(mapStateToProps);
